const ThreeDRotateIcon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 12C7.18491 16.8269 16.4642 16.3877 22 12.3556", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.5368 2C6.98939 6.5 6.48408 17 11.9941 22", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export { ThreeDRotateIcon as default };
//# sourceMappingURL=ThreeDRotateIcon.js.map
